import PropTypes from "prop-types";
import React from "react";

import { Image, StyleSheet } from "react-native";
import { connect } from "react-redux";

class DoctorAvatar extends React.Component {
  static propTypes = {
    avatarUrl: PropTypes.string
  };

  render() {
    const { avatarUrl, themeColors } = this.props;

    return (
      <Image
        source={{ uri: avatarUrl }}
        style={[
          styles.avatar,
          {
            backgroundColor: themeColors.lightestPrimary
          }
        ]}
      />
    );
  }
}

const styles = StyleSheet.create({
  avatar: {
    borderRadius: 15,
    height: 30,
    width: 30
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(DoctorAvatar);
